/* eslint-disable no-param-reassign */

function ifdev(el /* , binding, vnode */) {
    if (process.env.NODE_ENV !== 'development') {
        el.style.display = 'none';
    }
}

export default ifdev;
